module.exports = __webpack_public_path__ + "img/fsi.dbe768bc.png";